import { Check } from 'lucide-react';
import type { JobStatus } from '../../types/jobs';

interface JobStatusTimelineProps {
  status: JobStatus;
}

const STEPS: { key: JobStatus; label: string }[] = [
  { key: 'created', label: 'Created' },
  { key: 'assigned', label: 'Assigned' },
  { key: 'in_progress', label: 'In Progress' },
  { key: 'completed', label: 'Completed' },
];

const STATUS_ORDER: Record<string, number> = {
  created: 0, assigned: 1, in_progress: 2, paused: 2, completed: 3, cancelled: -1,
};

function JobStatusTimeline({ status }: JobStatusTimelineProps) {
  const currentIdx = STATUS_ORDER[status] ?? 0;
  const isCancelled = status === 'cancelled';

  return (
    <div className="flex items-center justify-between">
      {STEPS.map((step, idx) => {
        const isDone = !isCancelled && currentIdx > idx;
        const isCurrent = !isCancelled && currentIdx === idx;

        return (
          <div key={step.key} className="flex items-center flex-1 last:flex-none">
            <div className="flex flex-col items-center">
              <div
                className={`h-8 w-8 rounded-full flex items-center justify-center text-sm font-medium
                  ${isDone ? 'bg-success-600 text-white' : ''}
                  ${isCurrent ? 'bg-indigo-600 text-white ring-2 ring-indigo-200' : ''}
                  ${!isDone && !isCurrent ? 'bg-neutral-200 text-neutral-500' : ''}
                  ${isCancelled ? 'bg-red-100 text-red-500' : ''}
                `}
              >
                {isDone ? <Check className="h-4 w-4" /> : idx + 1}
              </div>
              <span className={`text-xs mt-1 ${isCurrent ? 'font-semibold text-indigo-700' : 'text-neutral-500'}`}>
                {step.label}
              </span>
            </div>
            {idx < STEPS.length - 1 && (
              <div
                className={`flex-1 h-0.5 mx-2 mt-[-1rem] ${
                  !isCancelled && currentIdx > idx ? 'bg-success-600' : 'bg-neutral-200'
                }`}
              />
            )}
          </div>
        );
      })}
      {isCancelled && (
        <div className="flex flex-col items-center ml-4">
          <div className="h-8 w-8 rounded-full flex items-center justify-center bg-red-500 text-white text-sm font-medium">
            ×
          </div>
          <span className="text-xs mt-1 font-semibold text-red-600">Cancelled</span>
        </div>
      )}
    </div>
  );
}

export default JobStatusTimeline;
